
  import { NAVIGATION } from '~/constants/navigation';

  export default {
    data () {
      return { menuOpen: false, selectedCategory: null };
    },
    computed: {
      disableNavMenu () {
        return ((this.meta && this.meta.disableNav) || this.$route.path.includes('results'));
      },
      meta () {
        return this.$store.getters['utils/getMeta'];
      },
      navigation () {
        return NAVIGATION;
      },
      profileImage () {
        return this.user.profile_image;
      },
      user () {
        return this.$store.getters['user/get'];
      }
    },
    watch: {
      menuOpen () {
        const bodyEl = document.getElementsByTagName('BODY')[0];
        if (this.menuOpen === true) {
          bodyEl.style.overflowY = 'hidden';
        } else {
          bodyEl.style.overflowY = 'visible';
        }
      }
    },
    methods: {
      toggleCategory (category) {
        this.selectedCategory = category || null;
      }
    }

  };
